export interface HashtagCategoryOption {
  id: string;
  label: string;
  color: string;
  icon: string;
}

export const HASHTAG_CATEGORY_OPTIONS: HashtagCategoryOption[] = [
  { id: 'lifestyle', label: 'Lifestyle', color: '#0E7490', icon: 'Sparkles' },
  { id: 'entretenimento', label: 'Entretenimento', color: '#5B21B6', icon: 'Popcorn' },
  { id: 'esportes', label: 'Esportes', color: '#047857', icon: 'Medal' },
  { id: 'beleza', label: 'Beleza', color: '#F59E0B', icon: 'Flower2' },
  { id: 'brasilidades', label: 'Brasilidades', color: '#65A30D', icon: 'Flag' },
  { id: 'musica', label: 'Música', color: '#D97706', icon: 'Music' },
  { id: 'games', label: 'Games', color: '#A78BFA', icon: 'Gamepad2' },
  { id: 'financas', label: 'Finanças', color: '#737373', icon: 'PiggyBank' },
  { id: 'alimentacao', label: 'Alimentação', color: '#DC2626', icon: 'Utensils' },
  { id: 'lar', label: 'Lar', color: '#86198F', icon: 'Home' },
  { id: 'geral', label: 'Geral', color: '#8890FE', icon: 'Home' },
];

export function getHashtagCategoryById(id: string): HashtagCategoryOption | undefined {
  return HASHTAG_CATEGORY_OPTIONS.find((c) => c.id === id);
}
